import React from "react";

function heat(){
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path d="M12.7454 23C18.8205 23 23.7454 18.0751 23.7454 12C23.7454 5.92487 18.8205 1 12.7454 1C6.67023 1 1.74536 5.92487 1.74536 12C1.74536 18.0751 6.67023 23 12.7454 23Z" stroke="#BABEC3" stroke-width="1.5"/>
      <path d="M12.4377 17C14.4769 17 16.7454 15.3584 16.7454 13.3333C16.7454 10.4692 15.664 9.75283 12.9944 6.65452C12.9169 6.56458 12.7522 6.67119 12.7979 6.78075C13.6537 8.83155 13.5336 10.3447 12.4377 10.8889C11.2846 11.4614 10.4916 10.246 10.0587 9.75521C10.0172 9.7081 9.94349 9.71522 9.90939 9.76799C8.98033 11.2059 8.74536 12.7363 8.74536 13.3333C8.74536 15.3584 10.3985 17 12.4377 17Z" stroke="#BABEC3" stroke-width="1.5"/>
    </svg>
    )
}
export default heat;